
import React from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Separator } from '@/components/ui/separator';

interface PwaDebugModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  debugInfo: {
    isIOS: boolean;
    isMobile: boolean;
    isInstallable: boolean;
    userAgent: string;
    osInfo: {
      name: string | undefined;
      version: string | undefined;
    };
    browserInfo: {
      name: string | undefined;
      version: string | undefined;
    };
    inStandaloneMode: boolean;
    storedDismissed: boolean;
    maxTouchPoints: number;
  };
}

export function PwaDebugModal({ open, onOpenChange, debugInfo }: PwaDebugModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>PWA Installation Debug Info</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4 text-sm">
          <div>
            <h3 className="font-semibold mb-1">Device Detection</h3>
            <div className="grid grid-cols-2 gap-2">
              <div className="text-muted-foreground">Is iOS:</div>
              <div>{debugInfo.isIOS ? '✅ Yes' : '❌ No'}</div>
              
              <div className="text-muted-foreground">Is Mobile:</div>
              <div>{debugInfo.isMobile ? '✅ Yes' : '❌ No'}</div>
              
              <div className="text-muted-foreground">Is Installable:</div>
              <div>{debugInfo.isInstallable ? '✅ Yes' : '❌ No'}</div>
            </div>
          </div>
          
          <Separator />
          
          <div>
            <h3 className="font-semibold mb-1">OS Information</h3>
            <div className="grid grid-cols-2 gap-2">
              <div className="text-muted-foreground">OS Name:</div>
              <div>{debugInfo.osInfo.name || 'Unknown'}</div>
              
              <div className="text-muted-foreground">OS Version:</div>
              <div>{debugInfo.osInfo.version || 'Unknown'}</div>
            </div>
          </div>
          
          <Separator />
          
          <div>
            <h3 className="font-semibold mb-1">Browser Information</h3>
            <div className="grid grid-cols-2 gap-2">
              <div className="text-muted-foreground">Browser Name:</div>
              <div>{debugInfo.browserInfo.name || 'Unknown'}</div>
              
              <div className="text-muted-foreground">Browser Version:</div>
              <div>{debugInfo.browserInfo.version || 'Unknown'}</div>
              
              <div className="text-muted-foreground">Max Touch Points:</div>
              <div>{debugInfo.maxTouchPoints}</div>
              
              <div className="text-muted-foreground">Standalone Mode:</div>
              <div>{debugInfo.inStandaloneMode ? '✅ Yes' : '❌ No'}</div>
              
              <div className="text-muted-foreground">Previously Dismissed:</div>
              <div>{debugInfo.storedDismissed ? '✅ Yes' : '❌ No'}</div>
            </div>
          </div>
          
          <Separator />
          
          <div>
            <h3 className="font-semibold mb-1">User Agent</h3>
            <div className="bg-muted p-2 rounded text-xs break-all">
              {debugInfo.userAgent}
            </div>
          </div>
        </div>
        
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
